import { render, staticRenderFns } from "./HistoricoImportacaoList.vue?vue&type=template&id=647c622d&scoped=true"
import script from "./HistoricoImportacaoList.vue?vue&type=script&lang=js"
export * from "./HistoricoImportacaoList.vue?vue&type=script&lang=js"
import style0 from "./HistoricoImportacaoList.vue?vue&type=style&index=0&id=647c622d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c622d",
  null
  
)

export default component.exports